import React from "react";
import "./HeaderComponent.css";
import config from "../../Configurations/KodakConfigUI.json";
import KodakIcon from "../../Resources/Icons/Kodak";
import { useTranslation } from "react-i18next";


const Header = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="navbar">
        <div className="left-section">
          <a href={t("HeaderLinks")}>
            <KodakIcon className="left-section-icon" />
          </a>
        </div>
      </div>
    </>
  );
};

export default Header;
